import * as React from "react";

function SvgIcons8Received(props, ref) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...{ ...props, ref }}>
      <path d="M3 7v18h13.063c.5 3.934 3.87 7 7.937 7 4.406 0 8-3.594 8-8 0-2.52-1.172-4.75-3-6.219V7zm4.313 2h17.375L16 14.781zM5 9.875l10.438 6.969.562.343.563-.343L27 9.875v6.719A7.827 7.827 0 0024 16c-4.066 0-7.438 3.066-7.938 7H5zM24 18c3.324 0 6 2.676 6 6s-2.676 6-6 6-6-2.676-6-6 2.676-6 6-6zm3.281 3.281L24 24.563l-2.281-2.282-1.438 1.438 3 3 .719.687.719-.687 4-4z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Received);
